module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('i', [_vm._v("Cast of Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("INSPECTOR QUEEN")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Old war horse of Centre Street. Only orders from Washington could have persuaded him to leave New York")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("ELLERY QUEEN")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("He was badly miscast as fall guy for a murderer")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("ABEL BENDIGO")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("The King’s ‘prime minister’. Deceptively undistinguished and blandly uncooperative")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("COLONEL SPRING")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("The gold-braided head of the King’s private Gestapo")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("KING KANE BENDIGO")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Munitions tycoon and monarch of Bendigo Island. Handsome, ruthless — but not invulnerable")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("JUDAH BENDIGO")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("The third brother. An ingenuous lush who specialized in Segonzac V.S.O.P.")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("KARLA BENDIGO")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("A Technicolor beauty who could have posed for Titian. Altogether, a fitting queen for the King")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("MAX")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("The King’s ‘court jester’. A troglodyte with only one loyalty")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("Dr. STORM")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Surgeon-General of Bendigo Island, whose conversation ran to the anatomically bawdy")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("IMMANUEL PEABODY")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Chief legal adviser to the King. Lean and swarthy, with a catty smile")]), _vm._v(" "), _c('p', {
    staticClass: "section-1"
  }, [_vm._v("Dr. AKST")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("A tired young man who, according to Karla, spent his time fiddling with atoms")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0